<template>
    <div>
        <div class="toolsc">
            <el-button type="primary" @click="goBackTap">返回上一页</el-button>
            <el-button type="primary" @click="submitForm('mForm')">保存配置</el-button>
        </div>
        <el-form ref="mForm" :model="mForm" label-width="140px">
            <el-form-item label="考核名称" prop="assesmentName" :rules="mFormRules.assesmentName">
                <el-input v-model="mForm.assesmentName" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="描述信息">
                <el-input v-model="mForm.remark" type="textarea" placeholder="请输入描述信息" clearable />
            </el-form-item>
            <el-form-item label="是否是智能组卷">
                <el-radio-group v-model="mForm.customerFlag">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="线上线下">
                <el-radio-group v-model="mForm.assesmentCategory">
                    <el-radio :label="0">线上考核</el-radio>
                    <el-radio :label="1">线下考核</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="线下地址" prop="assesmentAddress" :rules="mFormRules.assesmentAddress" v-if="mForm.assesmentCategory == 1" key="assesmentAddress">
                <el-input v-model="mForm.assesmentAddress" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="考核时间" prop="assesmentStartTime" :rules="mFormRules.assesmentStartTime">
                <el-date-picker v-model="mForm.assesmentStartTime" type="datetime" placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                至
                <el-date-picker v-model="mForm.assesmentEndTime" type="datetime" placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item label="考核班级" prop="classIdList" :rules="mFormRules.classIdList">
                <el-select style="width: 100%" v-model="mForm.classIdList" multiple clearable placeholder="请选择">
                    <el-option v-for="item in classList" :key="item.classerId" :label="item.classerName" :value="item.classerId"></el-option>
                </el-select>
            </el-form-item>
            <template v-if="mForm.customerFlag == 1 && mForm.assesmentCategory == 0">
                <el-form-item label="考核课程" prop="courseId" :rules="mFormRules.courseIdA" key="courseIdA">
                    <el-select style="width: 100%" v-model="mForm.courseId" clearable placeholder="全部课程">
                        <template v-for="(item, index) in courseList">
                            <el-option v-bind:key="index" :label="item.courseName" :value="item.courseId"></el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <el-form-item label="单个单选题分值" prop="singleChoicePoint" :rules="mFormRules.singleChoicePoint" key="singleChoicePoint">
                    <el-input v-model="mForm.singleChoicePoint" type="number" clearable></el-input>
                </el-form-item>
                <el-form-item label="单选题数量" prop="singleChoiceNumber" :rules="mFormRules.singleChoiceNumber" key="singleChoiceNumber">
                    <el-input v-model="mForm.singleChoiceNumber" type="number" clearable></el-input>
                </el-form-item>
                <el-form-item label="单个多选题分值" prop="multipleChoicePoint" :rules="mFormRules.multipleChoicePoint" key="multipleChoicePoint">
                    <el-input v-model="mForm.multipleChoicePoint" type="number" clearable></el-input>
                </el-form-item>
                <el-form-item label="多选题数量" prop="multipleChoiceNumber" :rules="mFormRules.multipleChoiceNumber" key="multipleChoiceNumber">
                    <el-input v-model="mForm.multipleChoiceNumber" type="number" clearable></el-input>
                </el-form-item>
                <el-form-item label="单个判断题分值" prop="judgmentPoint" :rules="mFormRules.judgmentPoint" key="judgmentPoint">
                    <el-input v-model="mForm.judgmentPoint" type="number" clearable></el-input>
                </el-form-item>
                <el-form-item label="判断题数量" prop="judgmentNumber" :rules="mFormRules.judgmentNumber" key="judgmentNumber">
                    <el-input v-model="mForm.judgmentNumber" type="number" clearable></el-input>
                </el-form-item>
                <el-form-item label="单个问答题分数" prop="questionPoint" :rules="mFormRules.questionPoint" key="questionPoint">
                    <el-input v-model="mForm.questionPoint" type="number" clearable></el-input>
                </el-form-item>
                <el-form-item label="问答题数量" prop="questionNumber" :rules="mFormRules.questionNumber" key="questionNumber">
                    <el-input v-model="mForm.questionNumber" type="number" clearable></el-input>
                </el-form-item>
            </template>
            <el-form-item label="考核课程" prop="courseId" :rules="mFormRules.courseIdB" v-if="mForm.customerFlag == 0 && mForm.assesmentCategory == 0" key="courseIdB">
                <el-select style="width: 100%" v-model="mForm.courseId" clearable placeholder="全部课程">
                    <template v-for="(item, index) in courseList">
                        <el-option v-bind:key="index" :label="item.courseName" :value="item.courseId"></el-option>
                    </template>
                </el-select>
            </el-form-item>
            <el-form-item label="考核课程" prop="courseId" :rules="mFormRules.courseIdB" v-if="mForm.assesmentCategory == 1" key="courseIdC">
                <el-select style="width: 100%" v-model="mForm.courseId" clearable placeholder="全部课程">
                    <template v-for="(item, index) in courseList">
                        <el-option v-bind:key="index" :label="item.courseName" :value="item.courseId"></el-option>
                    </template>
                </el-select>
            </el-form-item>
            <el-form-item label="考题选择" v-if="mForm.customerFlag == 0 && mForm.assesmentCategory == 0" key="topicCopys">
                <div class="frc">
                    <div style="width: 610px">
                        <ul class="table-title">
                            <li>已选考题</li>
                        </ul>
                        <el-table :data="topicCopys" tooltip-effect="dark" :stripe="true" border height="500px" :header-cell-style="tableHeaderCellStyle">
                            <el-table-column show-overflow-tooltip prop="topicContent" label="题目" align="center">
                            </el-table-column>
                            <el-table-column prop="topicTypeId" label="类型" align="center" width="100">
                                <template slot-scope="scope">{{ scope.row.topicTypeId | topicTypeFilter }}</template>
                            </el-table-column>
                            <el-table-column prop="mark" label="分数" align="center"></el-table-column>
                            <el-table-column align="center" label="操作" width="50">
                                <template slot-scope="scope">
                                    <div class="table-btn frc">
                                        <img class="table-btn-img" src="@/assets/del02.png" alt="" @click="handleDeleteTopic(scope.$index, scope.row)"/>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div style="height: 60px;background-color: #f4f8fb;"></div>
                    </div>
                    <div style="width: 600px; margin-left: 10px">
                        <ul class="table-title">
                            <li>考题库</li>
                            <li class="frc">
                                <el-select style="width: 100px" v-model="topicTypeId" placeholder="请选择类型" v-on:change="topicTypeChange(topicTypeId)">
                                    <el-option v-for="item in questionType" :key="item.topicTypeId" :label="item.topicTypeName" :value="item.topicTypeId"></el-option>
                                </el-select>
                            </li>
                        </ul>
                        <el-table :data="topics" tooltip-effect="dark" :stripe="true" border height="500px" :header-cell-style="tableHeaderCellStyle">
                            <el-table-column show-overflow-tooltip prop="topicContent" label="题目" align="center"></el-table-column>
                            <el-table-column prop="topicTypeId" label="类型" align="center" width="100">
                                <template slot-scope="scope">{{ scope.row.topicTypeId | topicTypeFilter }}</template>
                            </el-table-column>
                            <el-table-column prop="mark" label="分数" align="center"></el-table-column>
                            <el-table-column align="center" label="操作" width="50">
                                <template slot-scope="scope">
                                    <div class="table-btn frc">
                                        <img class="table-btn-img" src="@/assets/add02.png" alt="" @click="handleAdd(scope.$index, scope.row)"/>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination class="mb-pagination" @current-change="handleCurrentChange" :current-page="curPage" layout="total, prev, pager, next" :total="total"></el-pagination>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="考核总分" :rules="mFormRules.assesmentScore" key="assesmentScore">
                <el-input v-model="mForm.assesmentScore" type="number" :disabled="mForm.assesmentCategory == 0"></el-input>
            </el-form-item>
            <el-form-item label="及格分数" prop="passingScore" :rules="mFormRules.passingScore" key="passingScore">
                <el-input v-model="mForm.passingScore" type="number" clearable></el-input>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import CommonStyle from "@/utils/CommonStyle";
    let lengthA = 0; // 单选数量
    let lengthB = 0; // 多选数量
    let lengthC = 0; // 判断数量
    let lengthD = 0; // 问答数量
    let pointA = 0;
    let pointB = 0;
    let pointC = 0;
    let pointD = 0;
    let _courseId = null;
    let _scoreTotalA = 0;
    let _scoreTotalB = 0;
    let _scoreTotalC = 0;
    let _scoreTotalD = 0;
    export default {
        name: "AssessmentDepositoryEdit",
        components: {},
        data() {
            let validateCourseIdList = (rule, value, callback) => {
                if (value.length == 0) {
                    callback(new Error("请选择课程"));
                    return;
                }
                _courseId = value;
                this.HttpConnection.get("/learn/assesment/read/topic/number/", {
                    params: {
                        // topicTypeId: 1,
                        // mark: value,
                        courseId: _courseId
                    }
                }).then(function(response) {
                    lengthA = response.data;
                    if(lengthA == 0) {
                        callback(new Error("当前课程下无题目"));
                    } else {
                        console.log("-----", value);
                        callback();
                    }
                });
            };
            let validateSingleChoicePoint = (rule, value, callback) => {
                console.log("-----", value);
                if (value === null) {
                    callback(new Error("请填写分值"));
                    return;
                }
                this.HttpConnection.get("/learn/assesment/read/topic/number/", {
                    params: {
                        topicTypeId: 1,
                        mark: value,
                        courseId: _courseId
                    }
                }).then(function(response) {
                    lengthA = response.data;
                    if(lengthA == 0) {
                        callback(new Error("当前分值下无题目"));
                    } else {
                        pointA = value;
                        callback();
                    }
                });
            };
            let validateA = (rule, value, callback) => {
                if (value > lengthA || value < 1) {
                    callback(new Error("当前数量应小于等于"+ lengthA +"并且大于0"));
                } else if (value === null) {
                    callback(new Error("请填写单选题数量"));
                } else {
                    _scoreTotalA = value * pointA;
                    this.computedAssesmentScore();
                    callback();
                }
            };
            let validateMultipleChoicePoint = (rule, value, callback) => {
                if (value === null) {
                    callback(new Error("请填写分值"));
                    return;
                }
                this.HttpConnection.get("/learn/assesment/read/topic/number/", {
                    params: {
                        topicTypeId: 2,
                        mark: value,
                        courseId: _courseId
                    }
                }).then(function(response) {
                    lengthB = response.data;
                    if(lengthB == 0) {
                        callback(new Error("当前分值下无题目"));
                    } else {
                        pointB = value;
                        callback();
                    }
                });
            };
            let validateB = (rule, value, callback) => {
                if (value > lengthB || value < 1) {
                    callback(new Error("当前数量应小于等于"+ lengthB +"并且大于0"));
                } else if (value === null) {
                    callback(new Error("请填写多选题数量"));
                } else {
                    _scoreTotalB = value * pointB;
                    this.computedAssesmentScore();
                    callback();
                }
            };
            let validateJudgmentPoint = (rule, value, callback) => {
                if (value === null) {
                    callback(new Error("请填写分值"));
                    return;
                }
                this.HttpConnection.get("/learn/assesment/read/topic/number/", {
                    params: {
                        topicTypeId: 3,
                        mark: value,
                        courseId: _courseId
                    }
                }).then(function(response) {
                    lengthC = response.data;
                    if(lengthC == 0) {
                        callback(new Error("当前分值下无题目"));
                    } else {
                        pointC = value;
                        callback();
                    }
                });
            };
            let validateC = (rule, value, callback) => {
                if (value > lengthC || value < 1) {
                    callback(new Error("当前数量应小于等于"+ lengthC +"并且大于0"));
                } else if (value === null) {
                    callback(new Error("请填写判断题数量"));
                } else {
                    _scoreTotalC = value * pointC;
                    this.computedAssesmentScore();
                    callback();
                }
            };
            let validateQuestionPoint = (rule, value, callback) => {
                if (value === null) {
                    callback(new Error("请填写分值"));
                    return;
                }
                this.HttpConnection.get("/learn/assesment/read/topic/number/", {
                    params: {
                        topicTypeId: 4,
                        mark: value,
                        courseId: _courseId
                    }
                }).then(function(response) {
                    lengthD = response.data;
                    if(lengthD == 0) {
                        callback(new Error("当前分值下无题目"));
                    } else {
                        pointD = value;
                        callback();
                    }
                });
            };
            let validateD = (rule, value, callback) => {
                if (value > lengthD || value < 1) {
                    callback(new Error("当前数量应小于等于"+ lengthD +"并且大于0"));
                } else if (value === null) {
                    callback(new Error("请填写问答题数量"));
                } else {
                    _scoreTotalD = value * pointD;
                    this.computedAssesmentScore();
                    callback();
                }
            };
            return {
                tableHeaderCellStyle: CommonStyle.tableHeaderCellStyle,
                mForm: {
                    assesmentName: "",
                    remark: "",
                    customerFlag: 0,
                    assesmentCategory: 0,
                    assesmentAddress: "",
                    assesmentScore: 0,
                    passingScore: 0,
                    assesmentStartTime: "",
                    assesmentEndTime: "",
                    classIdList: [],
                    courseId: "",
                    chapterId: null,
                    classesId: null,

                    singleChoiceNumber: null,
                    singleChoicePoint: null,
                    multipleChoiceNumber: null,
                    multipleChoicePoint: null,
                    judgmentNumber: null,
                    judgmentPoint: null,
                    questionNumber: null,
                    questionPoint: null
                },
                mFormRules: {
                    assesmentName: [
                        { required: true, message: "请输入考核名称", trigger: "change" }
                    ],
                    classIdList: [
                        { required: true, message: "请选择班级", trigger: "change" }
                    ],
                    assesmentStartTime: [
                        { required: true, message: "请选择时间", trigger: "change" }
                    ],
                    classesId: [
                        { required: true, message: "请选择课时", trigger: "change" }
                    ],
                    assesmentAddress: [
                        { required: true, message: "请输入线下地址", trigger: "change" }
                    ],
                    assesmentScore: [
                        { required: true, message: "请输入总分", trigger: "change" }
                    ],
                    passingScore: [
                        { required: true, message: "请输入及格分数", trigger: "change" }
                    ],
                    courseIdA: [
                        { validator: validateCourseIdList, trigger: "change" }
                    ],
                    courseIdB: [
                        { required: true, message: "请选择课程", trigger: "change" }
                    ],
                    singleChoiceNumber: [
                        { validator: validateA, trigger: "change" }
                    ],
                    singleChoicePoint: [
                        { validator: validateSingleChoicePoint, trigger: "change" }
                    ],
                    multipleChoiceNumber: [
                        { validator: validateB, trigger: "change" }
                    ],
                    multipleChoicePoint: [
                        { validator: validateMultipleChoicePoint, trigger: "change" }
                    ],
                    judgmentNumber: [
                        { validator: validateC, trigger: "change" }
                    ],
                    judgmentPoint: [
                        { validator: validateJudgmentPoint, trigger: "change" }
                    ],
                    questionNumber: [
                        { validator: validateD, trigger: "change" }
                    ],
                    questionPoint: [
                        { validator: validateQuestionPoint, trigger: "change" }
                    ],
                },
                courseList: [],
                chapterList: [],
                classesList: [],

                topics: [],
                topicCopys: [],

                questionType: [],
                topicTypeId: 0,

                total: 0,
                curPage: 1,

                __assesmentId: null
            };
        },
        computed: {
            userInfo() {
                return this.$store.state.user.userInfo;
            },
            classList() {
                return this.$store.state.classer.classList;
            }
        },
        watch: {
            topicCopys() {
                let _assesmentScore = 0;
                if (this.topicCopys.length > 0) {
                    for (let item of this.topicCopys) {
                        _assesmentScore = _assesmentScore + item.mark;
                    }
                    this.mForm.assesmentScore = _assesmentScore;
                } else {
                    this.mForm.assesmentScore = 0;
                }
            }
        },
        filters: {
            topicTypeFilter(topicTypeId) {
                if (parseInt(topicTypeId) === 1) {
                    return "单选";
                } else if (parseInt(topicTypeId) === 2) {
                    return "多选";
                } else if (parseInt(topicTypeId) === 3) {
                    return "判断";
                } else if (parseInt(topicTypeId) === 4) {
                    return "问答";
                }
            }
        },
        mounted() {
            let that = this;
            that.topicList(1);
            that.topTypeList(this);
            that.getCourseList();
            // that.getChapterList();
            // that.getClassesList();
            that.$store.dispatch("classerList");
            let _assesmentId = that.$route.query.assesmentId;
            that.__assesmentId = _assesmentId;
            if(_assesmentId != null){
                that.HttpConnection.get(`/learn/assesment/getLearnAssesment/${_assesmentId}`).then(function(response) {
                    let _row = response.data;
                    that.mForm = {
                        assesmentId: _row.assesmentId,
                        assesmentName: _row.assesmentName,
                        remark: _row.remark,
                        customerFlag: 0,
                        assesmentCategory: _row.assesmentCategory,
                        assesmentAddress: _row.assesmentAddress,
                        assesmentScore: _row.assesmentScore,
                        passingScore: _row.passingScore,
                        assesmentStartTime: _row.assesmentStartTime,
                        assesmentEndTime: _row.assesmentEndTime,
                        classIdList: _row.classIdList,
                        courseId: _row.courseId,
                        chapterId: _row.chapterId,
                        classesId: _row.classesId,

                        singleChoiceNumber: null,
                        singleChoicePoint: null,
                        multipleChoiceNumber: null,
                        multipleChoicePoint: null,
                        judgmentNumber: null,
                        judgmentPoint: null,
                        questionNumber: null,
                        questionPoint: null
                    }
                    that.topicCopys = _row.learnTopics;
                });
            }
        },
        methods: {
            /*
            * 题库列表
            * */
            topicList(curPage) {
                let that = this;
                that.HttpConnection.get("/learn/topic/list", {
                    params: {
                        topicTypeId: that.topicTypeId,
                        topicContent: "",
                        pageNum: curPage,
                        pageSize: 10
                    }
                }).then(function(response) {
                    that.topics = response.rows;
                    that.total = response.total;
                });
            },
            /*
            * 问题类型列表
            * */
            topTypeList(that) {
                that.HttpConnection.get("/learn/toptype/list").then(function(response) {
                    that.questionTypeSelect = response.rows;
                    let _arrA = response.rows;
                    _arrA.unshift({
                        topicTypeId: 0,
                        topicTypeName: "全部"
                    });
                    that.questionType = _arrA;
                });
            },
            getCourseList() {
                let that = this;
                that.HttpConnection.get("/course/course/listCourseName").then(function(response) {
                    that.courseList = response.rows;
                });
            },
            getChapterList() {
                let that = this;
                that.HttpConnection.get("/course/chapter/list", {
                    params: {
                        courseId: that.mForm.courseId
                    }
                }).then(function(response) {
                    that.chapterList = response.rows;
                });
            },
            /*
            * 课时
            * */
            getClassesList() {
                let that = this;
                that.HttpConnection.get("/course/classes/classesNameList", {
                    params: {
                        chapterId: that.mForm.chapterId
                    }
                }).then(function(response) {
                    that.classesList = response.data;
                });
            },
            /*
            * 根据班级查询课程信息
            * */
            getCourseListB() {
                let that = this;
                that.HttpConnection.get("/classer/course/list", {
                    classerId: 1,
                }).then(function(response) {
                    that.courseList = response.rows;
                });
            },
            /*
            * 问题类型下拉框
            * */
            topicTypeChange(e) {
                this.curPage = 1;
                this.topicList(1);
            },
            /*
            * 课程下拉框
            * */
            courseChangeTap() {
                this.getChapterList();
            },
            /*
            * 章节下拉框
            * */
            chapterChangeTap() {
                this.getClassesList();
            },
            handleCurrentChange(val) {
                this.curPage = val;
                this.topicList(val);
            },
            handleAdd(index, row) {
                let that = this;
                for (let itema of this.topicCopys) {
                    if (itema.topicId === row.topicId) {
                        that.$message({
                            type: "error",
                            message: "当前已被选择!"
                        });
                        return;
                    }
                }
                this.topicCopys.push(row);
            },
            handleDeleteTopic(index, row) {
                this.topicCopys.splice(index, 1);
            },
            goBackTap() {
                this.$router.back(-1);
            },
            computedAssesmentScore(){
                this.mForm.assesmentScore = _scoreTotalA + _scoreTotalB + _scoreTotalC + _scoreTotalD;
            },
            submitForm(mForm) {
                let that = this;
                this.$refs[mForm].validate((valid) => {
                    if (valid) {
                        if (that.topicCopys.length == 0 && mForm.customerFlag == 0) {
                            that.$message.error("请至少选择一个考题");
                            return;
                        }
                        let _learnTopics = [];
                        for (let item of that.topicCopys) {
                            _learnTopics.push(item.topicId);
                        }
                        let _mForm = {
                            createBy: that.userInfo.nickName,
                            assesmentName: that.mForm.assesmentName,
                            remark: that.mForm.remark,
                            assesmentAllocation: 1,
                            customerFlag: that.mForm.customerFlag,
                            assesmentCategory: that.mForm.assesmentCategory,
                            assesmentAddress: that.mForm.assesmentAddress,
                            assesmentScore: that.mForm.assesmentScore,
                            passingScore: that.mForm.passingScore,
                            assesmentStartTime: that.mForm.assesmentStartTime,
                            assesmentEndTime: that.mForm.assesmentEndTime,
                            classIdList: that.mForm.classIdList,
                            topicIds: _learnTopics,
                            courseId: that.mForm.courseId,
                            chapterId: that.mForm.chapterId,
                            classesId: that.mForm.classesId,
                            smartGenerateTopic: {
                                singleChoiceNumber: that.mForm.singleChoiceNumber,
                                singleChoicePoint: that.mForm.singleChoicePoint,
                                multipleChoiceNumber: that.mForm.multipleChoiceNumber,
                                multipleChoicePoint: that.mForm.multipleChoicePoint,
                                judgmentNumber: that.mForm.judgmentNumber,
                                judgmentPoint: that.mForm.judgmentPoint,
                                questionNumber: that.mForm.questionNumber,
                                questionPoint: that.mForm.questionPoint,
                            }
                        }
                        // console.log("that.mForm----->", _mForm);
                        // console.log("that.mForm----->", JSON.stringify(_mForm));
                        if(that.__assesmentId == null){
                            that.HttpConnection.post("/learn/assesment/save", _mForm).then(function(response) { that.$router.back(-1); });
                        } else {
                            _mForm.assesmentId = that.mForm.assesmentId;
                            that.HttpConnection.put("/learn/assesment/edit", _mForm).then(function(response) { that.$router.back(-1); });
                        }
                    }
                });
            }
        }
    };
</script>

<style scoped lang="scss">
    .table-title{
        background-color: #F5F7FA;
        padding: 10px 10px 10px 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
    .btn-a{
        color: #20a0ff;
        margin: 0px 12px 0px 0px;
        cursor: pointer;
    }
</style>
